import { forwardRef, type Ref, type SVGProps } from "react";
const IconExclamationCircleOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M25.9 6.1A14 14 0 1 0 30 16a13.94 13.94 0 0 0-4.1-9.9m-1.41 18.39A12 12 0 1 1 28 16a12 12 0 0 1-3.51 8.49"
    />
    <path
      fill="currentColor"
      d="M18 22a2 2 0 0 1-4 0 2 2 0 0 1 2-2 2 2 0 0 1 2 2m0-12.81L17.2 17a1.22 1.22 0 0 1-2.4 0L14 9.19a2 2 0 1 1 4 0"
    />
  </svg>
);
const ForwardRef = forwardRef(IconExclamationCircleOutlineSVG);
ForwardRef.displayName = "IconExclamationCircleOutline";
export { ForwardRef as IconExclamationCircleOutline };
